<form [formGroup]="addressForm" class="address-form-container">
  <ion-row class="wrapper ion-margin-top pl-32">
    <!-- Company Name -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.COMPANY_NAME"
          [maxLength]="25"
          [form]="addressForm"
          [regexType]="SpecialCharacters.DOT_SPACE_ALLOW"
          [control]="FORM_CONTROLS.COMPANY_NAME"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper pl-32">
    <!-- Address 1 -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.ADDRESS_1"
          [maxLength]="30"
          [form]="addressForm"
          [regexType]="SpecialCharacters.DOT_SPACE_ALLOW"
          [control]="FORM_CONTROLS.ADDRESS"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- Address 2 -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.ADDRESS_2"
          [maxLength]="30"
          [form]="addressForm"
          [regexType]="SpecialCharacters.DOT_SPACE_ALLOW"
          [control]="FORM_CONTROLS.ADDRESS_2"
          [hasRequiredSign]="false"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper pl-32">
    <!-- City -->
    <ion-col size="auto">
      <div class="form-group city-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.CITY"
          [maxLength]="30"
          [form]="addressForm"
          [regexType]="SpecialCharacters.ADDRESS"
          [control]="FORM_CONTROLS.CITY"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- State -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.STATE_PROVINCE"
          [maxLength]="2"
          [form]="addressForm"
          [regexType]="SpecialCharacters.ALPHABET_ONLY"
          [control]="FORM_CONTROLS.STATE"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- Postal code -->
    <ion-col size="auto">
      <div class="form-group small-input-group mr-9">
        <app-form-text-field
          [labelText]="CONSTANTS.POSTAL_CODE"
          [maxLength]="8"
          [form]="addressForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="FORM_CONTROLS.POSTAL_CODE"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Country -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-select
          [label]="CONSTANTS.COUNTRY"
          [options]="iOptionCountries"
          [formControlName]="FORM_CONTROLS.COUNTRY"
          [required]="true"
        >
        </app-form-select>
      </div>
    </ion-col>
    <!-- Currency -->
    <ion-col size="auto">
      <div class="form-group currency-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.CURRENCY"
          [maxLength]="3"
          [form]="addressForm"
          [regexType]="ALPHABET_REGEX"
          [control]="FORM_CONTROLS.CURRENCY"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper m-lr-32 border-b-gray">
    @if (edit) {
      <ion-col size="12" class="ion-no-padding">
        <p class="lat-long-required-info">
          <i
            >*
            {{ CONSTANTS.LAT_LONG_REQUIRED_INFO }}
            {{ CONSTANTS.IDO_ENABLED_LOCATION }}
          </i>
        </p>
      </ion-col>
    }
    <!-- Latitude -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.LATITUDE"
          [form]="addressForm"
          [control]="FORM_CONTROLS.LATITUDE"
          [maxLength]="14"
          [invalidPatternMessage]="CONSTANTS.INVALID_LATITUDE"
          [hasRequiredSign]="checkRouteDeliveryOrder()"
          [requiredErrorMessage]="
            CONSTANTS.LAT_LONG_REQUIRED.replace('%s', CONSTANTS.LATITUDE)
          "
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Longitude -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.LONGITUDE"
          [form]="addressForm"
          [control]="FORM_CONTROLS.LONGITUDE"
          [maxLength]="14"
          [invalidPatternMessage]="CONSTANTS.INVALID_LONGITUDE"
          [hasRequiredSign]="checkRouteDeliveryOrder()"
          [requiredErrorMessage]="
            CONSTANTS.LAT_LONG_REQUIRED.replace('%s', CONSTANTS.LONGITUDE)
          "
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper pl-32 ion-margin-top">
    <!-- Contact Name -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.CONTACT_NAME"
          [maxLength]="50"
          [form]="addressForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="FORM_CONTROLS.CONTACT_NAME"
          [hasRequiredSign]="false"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- Secondary Contact Name -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.SECONDARY_CONTACT_NAME"
          [maxLength]="50"
          [form]="addressForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="FORM_CONTROLS.CONTACT_NAME_2"
          [hasRequiredSign]="false"
          [isItalicLabel]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper pl-32">
    <!-- Contact Email -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.CONTACT_EMAIL"
          [maxLength]="50"
          [form]="addressForm"
          [control]="FORM_CONTROLS.CONTACT_EMAIL"
          [regexType]="SpecialCharacters.EMAIL"
          [hasRequiredSign]="false"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- Secondary Contact Email -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.SECONDARY_CONTACT_EMAIL"
          [maxLength]="50"
          [form]="addressForm"
          [control]="FORM_CONTROLS.CONTACT_EMAIL_2"
          [regexType]="SpecialCharacters.EMAIL"
          [hasRequiredSign]="false"
          [isItalicLabel]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="wrapper pl-32">
    <!-- Contact Phone -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.CONTACT_PHONE"
          [maxLength]="25"
          [form]="addressForm"
          [regexType]="SpecialCharacters.NUMBER_ONLY"
          [control]="FORM_CONTROLS.CONTACT_PHONE"
          [hasRequiredSign]="false"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!-- Secondary Contact Phone -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.SECONDARY_CONTACT_PHONE"
          [maxLength]="25"
          [form]="addressForm"
          [regexType]="SpecialCharacters.NUMBER_ONLY"
          [control]="FORM_CONTROLS.CONTACT_PHONE_2"
          [hasRequiredSign]="false"
          [isItalicLabel]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>
</form>

<!-- footer -->
<div class="address-footer">
  <app-footer-action-bar
    [form]="addressForm"
    [edit]="edit"
    [btnEnabled]="formState.canSubmit"
    [resetBtnEnabled]="formState.canReset"
    (submitBtnClick)="submitAddressForm()"
    (resetBtnClick)="resetAddressForm()"
  ></app-footer-action-bar>
</div>
<!------------>
